import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Typography, Box } from '@mui/material'
import { format, setMonth, setYear } from '@e3dc-react/shell/Libs/date'
import { BasicSystemResponseModel } from 'src/Libs/shop/models'
import { makeStyles } from 'tss-react/mui'
import { ShippingDate } from 'src/State/ShopSystemConfiguration/ShopSystemConfigurationModel'

interface FixFlexSystemConfigurationProps {
  basicData: BasicSystemResponseModel | null
  deliveryDate: ShippingDate | null
}

const useStyles = makeStyles()(theme => ({
  customFixFlex: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.main,
    padding: theme.spacing(2),
    borderRadius: '12px',
  },
}))

const FixFlexBasicSystemCard: React.FC<FixFlexSystemConfigurationProps> = ({ basicData, deliveryDate }) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()
  const fixFlexMonth = deliveryDate && basicData?.fixFlex?.[Number(deliveryDate.year)]?.[Number(deliveryDate.month) + 1]
  const fixAvailable = fixFlexMonth?.fixAvailable || 0
  const isFixAmount = fixAvailable !== 0
  const availabilityText = isFixAmount ? t('shop.system-configure-card.fix-available') : t('shop.system-configure-card.flex-available')

  const formattedDate =
    deliveryDate && format(setMonth(setYear(new Date(), Number(deliveryDate.year)), Number(deliveryDate.month) || 0), 'MMM yyyy').replace('.', '')

  const title = isFixAmount ? `${fixAvailable} ${availabilityText} ${formattedDate}` : `${availabilityText} ${formattedDate}`

  return (
    <Box>
      {basicData ? (
        <Typography variant="h4" className={classes.customFixFlex}>
          {title}
        </Typography>
      ) : (
        <Typography variant="h4">{t('shop.system-configure-card.not-selected-yet')}</Typography>
      )}
    </Box>
  )
}
export default FixFlexBasicSystemCard
